/** Matches tix-api-comms skip list: receipts are not sent to these addresses. */
const PLACEHOLDER_EMAIL_PREFIXES = ['no-email+', 'no-email@'] as const

export function isPlaceholderEmail(email: string | null | undefined): boolean {
  if (!email) return false
  return PLACEHOLDER_EMAIL_PREFIXES.some((prefix) => email.startsWith(prefix))
}
